import(/* webpackMode: "eager" */ "/app/src/app/(dashboard)/error.tsx");
